export var Operation;
(function (Operation) {
    Operation[Operation["Show"] = 1] = "Show";
    Operation[Operation["Hide"] = 2] = "Hide";
    Operation[Operation["Required"] = 3] = "Required";
    Operation[Operation["Optional"] = 4] = "Optional";
})(Operation || (Operation = {}));
//# sourceMappingURL=rule.js.map